module.exports = __webpack_public_path__ + "static/media/documents-white.2fdeb234.svg";